import type { Observable } from 'rxjs';
import { combineLatest } from 'rxjs';
import { defaultIfEmpty, distinctUntilChanged, map } from 'rxjs/operators';

/**
 * Check all the observable arguments are true.
 */
export function allTrue(
  ...observables: Observable<boolean>[]
): Observable<boolean> {
  return combineLatest(
    observables.map(observable$ => observable$.pipe(defaultIfEmpty(false))),
  ).pipe(
    map(args => args.every(x => x)),
    distinctUntilChanged(),
  );
}
